export const OneTapLoginConstants = {
  CLIENT_ID: "746155480363-625uap16ecpl7u9s2i14uqg1tiri9nch.apps.googleusercontent.com",
  REDIRECT_PATH: "/control/googleResponse",
};
